const customParamSerializer = (params) => {
  let searchParams = "";
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      searchParams += value
        .map((item) => {
          const trimmedItem = typeof item === "string" ? item.trim() : item;
          return `${key}[]=${encodeURIComponent(trimmedItem)}`;
        })
        .join("&");

      searchParams += value.length ? "&" : "";
      return;
    }

    const trimmedValue = typeof value === "string" ? value.trim() : value;
    searchParams += `${key}=${encodeURIComponent(trimmedValue)}&`;
  });

  return searchParams.substring(0, searchParams.length - 1);
};

export default customParamSerializer;
